module.exports = __webpack_public_path__ + "img/section5-item2.45eda86f.svg";